import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import s from './MapPage.module.css';
import { domain } from '../../store/authSlice';

export const TrapMapPage = () => {
  const [trapPoints, setTrapPoints] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    axios.get(domain + 'api/trap-points/')
      .then(res => setTrapPoints(res.data))
      .catch(err => console.error('Ошибка при загрузке точек звуколовушек:', err));
  }, []);

  return (
    <div style={{ position: 'relative', height: '90vh', width: '100%' }}>
      <button className={s.backButton} onClick={() => navigate(-1)}>
        {t('back_to_collection')}
      </button>

      {/* карта */}
      <YMaps query={{ apikey: 'ce4ea19b-77cf-4121-b9ba-e88501f65833' }}>
        <Map defaultState={{ center: [53.9, 27.5667], zoom: 7 }} width="100%" height="100%">
          {trapPoints.map((point, index) => {
            const dateFrom = new Date(point.date_from).toLocaleDateString();
            const dateTo = new Date(point.date_to).toLocaleDateString();

            return (
              <Placemark
                key={index}
                geometry={[point.lat, point.lng]}
                properties={{
                  balloonContent: `
                    <div style="max-width: 250px;">
                      <strong>${t('files_count')}:</strong> ${point.count_files}<br/>
                      <strong>${t('date_range')}:</strong><br/>
                      ${dateFrom} — ${dateTo}
                    </div>
                  `
                }}
                options={{
                  preset: 'islands#icon',
                  iconColor: '#FF0000', 
                  balloonMaxWidth: 400,
                  balloonAutoPan: true
                }}
                modules={['geoObject.addon.balloon']}
              />
            );
          })}
        </Map>
      </YMaps>
    </div>
  );
};